<template>
  <div class=" mx-auto mb-10 h-screen">
    <div class="flex justify-between">
      <div class="w-full md:w-2/5 h-full flex-col">
      <!-- Need to update the 'No Instructors Found' to the InstructorName and remove the Recommended dropdown -->
        <FindInstructorHeader
          class="hidden md:block"
        />
        <InstructorProfileContact
          class="hidden md:block"
          :name="filteredInstructor.name"
        />
      </div>
      <div class="md:w-3/5 h-screen">
        <InstructorProfileHeader
          :name="filteredInstructor.name"
          :formatted_phone_number="filteredInstructor.formatted_phone_number"
          :rating="filteredInstructor.rating"
          :website="filteredInstructor.website"
          :address="filteredInstructor.formatted_address"
          :image="filteredInstructor.photos ? filteredInstructor.photos[0].getUrl() : '/default_photo.png'"
        />
        <InstructorProfileContact
          class="md:hidden w-11/12 mx-auto"
          :name="filteredInstructor.name"
        />
        <InstructorProfileBody/>
        <!-- <InstructorProfileCal /> -->
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash.get'
import meta from './meta'
import InstructorProfileHeader from './InstructorProfileHeader'
import InstructorProfileBody from './InstructorProfileBody'
// import InstructorProfileCal from './InstructorProfileCal'
import InstructorProfileContact from './InstructorProfileContact'
import FindInstructorHeader from '../FindInstructor/FindInstructorHeader'

export default {
  name: 'InstructorProfileDefault',
  mixins: [meta],
  components: {
    InstructorProfileHeader,
    InstructorProfileBody,
    // InstructorProfileCal,
    InstructorProfileContact,
    FindInstructorHeader
  },
  computed: {
    filteredInstructor () {
      return get(this.$store.state.instructorModule, 'selectedInstructor', null)
    }
  }
}
</script>
